import React from 'react';

import { cn } from '@infinex/ui-styles';

interface Props {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
  isTabView?: boolean; // Pass this prop to indicate if running in tab view
}

export const FullscreenContainer = ({
  children,
  className,
  style,
  isTabView = false,
}: Props) => {
  // Render children directly when in tab view context
  if (isTabView) {
    return <>{children}</>;
  }

  return (
    <div
      className={cn(
        'bg-canvas flex h-full min-h-0 w-full flex-col items-center justify-center',
        className
      )}
      style={style}
    >
      <div
        className={cn(
          'relative h-full min-h-0 w-full translate-x-0 transform bg-[#050609]',
          // Allow additional classes from callers
          className
        )}
        style={style}
      >
        {children}
      </div>
    </div>
  );
};
